import { render, staticRenderFns } from "./FancySlider.vue?vue&type=template&id=2ffb8c0a"
import script from "./FancySlider.vue?vue&type=script&lang=js"
export * from "./FancySlider.vue?vue&type=script&lang=js"
import style0 from "./FancySlider.vue?vue&type=style&index=0&id=2ffb8c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports